import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
import { FaInstagram, FaTiktok } from 'react-icons/fa';
import { Icon } from '../shared/Icon';
import logo from '../logo.svg';

const ModernFooter = styled.footer`
  background: var(--brand);
  color: #fff;
  padding: 2.5rem 0 1.5rem 0;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  margin-top: 2rem;
`;
const FooterBox = styled.div`
  position: relative;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
`;
const FooterLogoLink = styled(Link)`
  position: absolute;
  left: -15rem;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 900px) {
    position: static;
    transform: none;
    margin-bottom: 0.5rem;
  }
`;
const FooterLogoImg = styled.img`
  height: 200px;
  width: auto;
  display: block;
  filter: brightness(0) invert(1);

  @media (max-width: 600px) {
    height: 130px;
  }
`;
const FooterContact = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.08rem;
`;
const FooterCopyright = styled.div`
  text-align: center;
  font-size: 0.98rem;
  color: #e6edfa;
  margin-top: 1rem;
`;
const FooterLegalLinks = styled.div`
  display: flex;
  gap: 1.2rem;
  justify-content: center;
  margin-top: 0.75rem;
`;
const FooterLegalLink = styled(Link)`
  color: #fff;
  font-size: 0.95rem;
  text-decoration: underline;
  &:hover {
    color: #e6edfa;
  }
`;

const Footer: React.FC = () => (
  <ModernFooter>
    <FooterBox>
      <FooterLogoLink to="/" aria-label="AP Clean Services Startseite">
        <FooterLogoImg src={logo} alt="AP Clean Services" />
      </FooterLogoLink>
      <FooterContact>
        <div><Phone style={{ marginRight: 8, verticalAlign: 'middle' }} /> <a href="tel:+491729182451" style={{ color: '#fff', textDecoration: 'underline' }}>+491729182451</a></div>
        <div><Mail style={{ marginRight: 8, verticalAlign: 'middle' }} /> <a href="mailto:info@apcleanservices.de" style={{ color: '#fff', textDecoration: 'underline' }}>info@apcleanservices.de</a></div>
        <div className='social-channels'>
          <span style={{ marginRight: 8, verticalAlign: 'middle' }}>Folge uns:</span>
          <a href="https://instagram.com/ap_cleanservices" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle', gap: 4 }}>
            <Icon icon={FaInstagram} style={{ fontSize: '1.5rem', marginRight: 4 }} />
          </a>
          <a href="https://tiktok.com/@ap_cleanservices" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle', gap: 4 }}>
            <Icon icon={FaTiktok} style={{ fontSize: '1.5rem', marginRight: 4 }} />
          </a>
        </div>
      </FooterContact>
      <div style={{ textAlign: 'center', marginTop: '1.5rem', paddingTop: '1rem', borderTop: '1px solid rgba(255,255,255,0.2)' }}>
        <div style={{ fontSize: '0.9rem', marginBottom: '0.5rem' }}>
          <strong>Impressum</strong> | AP Clean Services | Inhaber: Abimanju Premachandran |
          Moltkestr. 20, 33330 Gütersloh | Tel: +49 172 9182451 |
          E-Mail: info@apcleanservices.de | USt-IdNr: DE457367373
        </div>
        <div style={{ fontSize: '0.85rem', color: '#e6edfa' }}>
          Haftungsausschluss: Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links.
        </div>
      </div>
      <FooterLegalLinks>
        <FooterLegalLink to="/impressum">Impressum</FooterLegalLink>
        <FooterLegalLink to="/datenschutz">Datenschutzerklärung</FooterLegalLink>
      </FooterLegalLinks>
      <FooterCopyright>© {new Date().getFullYear()} AP Clean Services. Alle Rechte vorbehalten.</FooterCopyright>
    </FooterBox>
  </ModernFooter>
);

export default Footer;
